import { BaseApiService } from '@services/baseApiService';
import { CategoryDocumentOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class CategoryDocumentService extends BaseApiService<CategoryDocumentOutputDTO> {
  constructor() {
    super('categories-documents');
  }

  async create(data: Partial<CategoryDocumentOutputDTO>): Promise<ApiResponse<CategoryDocumentOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.create(roleData);
  }

  async update(id: string, data: Partial<CategoryDocumentOutputDTO>): Promise<ApiResponse<CategoryDocumentOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const roleData = {
      ...data,
    };
    
    return await super.update(id, roleData);
  }

  // You can add role-specific methods here if needed
}

export const categoryService = new CategoryDocumentService(); 